"use client";

import { useEffect } from "react";
import { keepFirstTouch } from "@/lib/attribution";

export default function FirstTouch() {
  useEffect(() => keepFirstTouch(), []);
  return null;
}
